/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./sizeSelect.vue?vue&type=template&id=71a48a10"
import script from "./sizeSelect.vue?vue&type=script&lang=js"
export * from "./sizeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports